import {
  agentIsTyping,
  chatEnded,
  chatEntranceClosed,
  chatError,
  chatFinished,
  chatMessageReceived,
  chatPlacedInQueueByAgent,
  chatSessionEstablished,
  chatSessionQueued,
  chatSessionStarted,
  chatStateFetched
} from '../redux/slices/chat-state';
import { receiveConfig } from '../redux/slices/config';
import { AppDispatch } from '../redux/store';
import {
  BaseEvent,
  ChatEntryEvent,
  EmailResultEvent,
  ErrorEvent,
  ReadyEvent
} from '../types/call-guide/events';
import { ChatSessionState } from '../types/call-guide/state';
import { boostSession, chatSession } from '../utils/session';
import { toggleChatWindowVisible } from './chatWindowVisibilityActions';
import {
  fetchNumberOfUnreadMessages,
  resetNumberOfUnreadMessages,
  updateNumberOfUnreadMessages
} from './unreadMessagesActions';

// FIXME: Arguments to this don't match Telia docs..
export function ready(chatState: ChatSessionState | ReadyEvent) {
  const event = typeof chatState === 'string' ? chatState : chatState.state;
  if (typeof chatState === 'string') {
    console.warn('ready payload was string, expected object');
  }
  if (!boostSession.exists()) {
    return (dispatch: AppDispatch) => {
      dispatch(chatStateFetched(event));
      if (event === 'noSession') {
        dispatch(resetNumberOfUnreadMessages());
      } else {
        dispatch(fetchNumberOfUnreadMessages());
      }
    };
  }
  return {
    type: 'CHAT_STATE_FETCHED_IGNORE_HAS_ROBOT_SESSION'
  };
}

export function startup(startupObj: BaseEvent) {
  return (dispatch: AppDispatch) => {
    dispatch(chatSessionStarted(startupObj));
    dispatch(toggleChatWindowVisible(true));
  };
}

export const queue = chatSessionQueued;

export const established = chatSessionEstablished;

export const placedInQueue = chatPlacedInQueueByAgent;

export const afterChat = chatEnded;

export const finished = chatFinished;

export function error(errorObj: ErrorEvent) {
  return (dispatch: AppDispatch) => {
    dispatch(chatError(errorObj));
    dispatch(toggleChatWindowVisible(true));
  };
}

export const entranceClosed = chatEntranceClosed;

export type RobotChatEntryEvent = ChatEntryEvent & {
  objectType: 'chatEntry';
  objectId: string;
};

export function chatEntry(entryObj: ChatEntryEvent | RobotChatEntryEvent) {
  return (dispatch: AppDispatch) => {
    dispatch(chatMessageReceived(entryObj));
    if (!chatSession.didRefresh() && !chatSession.isWindowVisible()) {
      dispatch(updateNumberOfUnreadMessages());
    }
  };
}

export const config = receiveConfig;

export function messageSent() {
  return {
    type: 'CHAT_MESSAGE_SENT'
  };
}

export const penStatus = agentIsTyping;

export function emailResult(emailResultObj: EmailResultEvent) {
  return {
    type: 'CHAT_EMAIL_REQUESTED',
    emailResultObj
  };
}

export function noSession(noSessionObj: BaseEvent) {
  if (!boostSession.exists()) {
    return {
      type: 'CHAT_INITIALIZED_NO_SESSION',
      noSessionObj
    };
  }
  return {
    type: 'CHAT_INITIALIZED_NO_SESSION_IGNORE_HAS_ROBOT_SESSION'
  };
}
